module.exports = __webpack_public_path__ + "static/media/PLANETA.51a6594a.png";